__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "template";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("react-alert-template-basic", "1.0.2", () => (Promise.all([__webpack_require__.e(416), __webpack_require__.e(323)]).then(() => (() => (__webpack_require__(2323))))));
			register("react-alert", "7.0.3", () => (Promise.all([__webpack_require__.e(220), __webpack_require__.e(416), __webpack_require__.e(51)]).then(() => (() => (__webpack_require__(5220))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(416)]).then(() => (() => (__webpack_require__(3961))))));
			register("react-router-dom", "5.2.0", () => (Promise.all([__webpack_require__.e(878), __webpack_require__.e(416)]).then(() => (() => (__webpack_require__(5878))))));
			register("react", "18.2.0", () => (__webpack_require__.e(526).then(() => (() => (__webpack_require__(9526))))));
			initExternal(5047);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};